import { useTranslations } from "use-intl";

import type { FlightFormLocation } from "@/types/types";

type LocationNameProps = {
  location: FlightFormLocation;
};

export function LocationName({ location }: LocationNameProps) {
  const t = useTranslations();

  return (
    <>
      {location.name}

      {location.type === "CITY" && (
        <>
          <span className="mx-1 text-stroke-neutral-medium">&bull;</span>
          {t("flights.search.allAirports")}
        </>
      )}
    </>
  );
}
